export default "../../src/img/bg_most.jpg";